<template>
  <el-tooltip content="Add Contact" placement="bottom">
    <el-button circle style="width: 35px; height: 35px" @click="goToContacts">
      <fa-icon :icon="faAddressBook" class="text-[16px]" />
    </el-button>
  </el-tooltip>
</template>
<script>
import { faAddressBook } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'vue-router'

export default {
  name: 'HeaderContacts',
  setup() {
    const router = useRouter()

    const goToContacts = () => {
      router.push({ name: 'advisor/contacts' })
    }

    return {
      faAddressBook,
      goToContacts,
    }
  },
}
</script>
